import {defineStore} from "pinia";
import {useApiStore} from "@/stores/api";
import {Branch} from "@/types/site_admin/branches";
import {ref} from "vue";

export const useBranchesStore = defineStore("branches", () => {
    const api = useApiStore();
    const branches = ref<Branch[]>([] as Branch[]);
    const storedBranchId = localStorage.getItem('current-branch-id');
    const currentBranchId = ref<number | null>(null);
    if (storedBranchId !== null) {
        currentBranchId.value = Number(storedBranchId);
    }

    function getBranches(relations: string | string[] | undefined = undefined) : Promise<void> {
        return new Promise((resolve, reject) => {
            api.getItems('branches', Branch, relations)
                .then((response) => {
                    branches.value = response;
                    resolve();
                })
                .catch((error) => {
                    console.log('store function error', error);
                    reject("An error has occurred");
                })
        });
    }

  function createBranch(branch: Branch | any, relations: string | string[] | undefined = undefined): Promise<void> {
    return new Promise(async (resolve, reject) => {
      api.createItem('branches', branch, Branch, null, relations)
        .then((response) => {
          branches.value.push(response);
          resolve();
        })
        .catch((error) => {
          console.log("store function error", error);
          reject("An error has occurred");
        });
    });
  }

  function setCurrentBranch(branch_id: number | null): void {
    currentBranchId.value = branch_id;
    if (branch_id === null) {
      localStorage.removeItem('current-branch-id');
    } else {
      localStorage.setItem('current-branch-id', String(branch_id));
    }
  }

  return {branches, currentBranchId, createBranch, getBranches, setCurrentBranch};
});
